var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageSkelaton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 116,
    rx: 4,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.988 61.0568L63.6452 57.7123C63.3081 57.5407 62.901 57.608 62.6345 57.8793L56.4297 64.1969C56.2604 64.3693 55.9921 64.396 55.7922 64.2603L51.4811 61.334C51.1338 61.0982 50.6714 61.1448 50.3763 61.4453L45.0068 66.1512",
    stroke: "#717784"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8709 54.6879C53.3216 54.6879 54.4977 53.4905 54.4977 52.0134C54.4977 50.5363 53.3216 49.3389 51.8709 49.3389C50.4202 49.3389 49.2441 50.5363 49.2441 52.0134C49.2441 53.4905 50.4202 54.6879 51.8709 54.6879Z",
    stroke: "#717784"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 26,
    height: 26,
    rx: 3.5,
    stroke: "#717784"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSkelaton);
export default __webpack_public_path__ + "static/media/image-skelaton.7326764892ff9f27291a56c3876b267d.svg";
export { ForwardRef as ReactComponent };